<template>
    <div>
        <div class="wrapper">
            <!-- 债权人/管理人 -->
            <CreditorsMeeting v-if="userInfo.type !== 'ADMIN'" :loading="loading" :total="total" :searchForm="meetingForm"
                :tableData="tableData" @search="searchMeeting" @enter="enterMeeting" @sure="toggleVisible" />
            <!-- 超管 -->
            <AdminMeeting v-else :tableData="tableData" :loading="loading" :meetingForm="meetingForm" :total="total"
                @enter="enterMeeting" @sure="toggleVisible" @add="addMeeting" @edit="editMeeting"
                @refreshList="getMeetingList" @config="getMeetingConfig" @toggle="toggleMeeting" @search="searchMeeting" />
            <!-- 新建/编辑会议弹出层 -->
            <AddMeeting :newDialogVisible="newDialogVisible" :isEdit="isEdit" :ruleForm="ruleForm"
                :managerList="managerList" @refreshList="getMeetingList" @cancel="toggleVisible" />
            <!-- 进入会议弹出层 -->
        <!-- <EnterMeeting :meetingInfo="meetingInfo" :meetingData="meetingData" :isBtnShow="isBtnShow"
                :goIntoDialogVisible="goIntoDialogVisible" @cancel="toggleVisible" /> -->
                
            <!-- 视频配置弹出层 -->
            <VideoConfig :centerDialogVisible="centerDialogVisible" :domainList="domainList" :config="config"
                :meetingId="meetingId" :isConfigEdit="isConfigEdit" :configForm="configForm" :meetingInfo="meetingInfo"
                @cancel="toggleVisible" @reset="resetForm" @refresh="getMeetingConfig" @defaultSet="defaultSet" />
            <!-- 线路列表弹出层 -->
            <LineList :lineDialogVisible="lineDialogVisible" :config="config" @cancelVisible="toggleVisible"
                @edit="editLine" @add="toggleVisible" @defaultSet="defaultSet"/>
        </div>
    </div>
</template>

<script>
import AddMeeting from './components/meeting/addMeeting';
import EnterMeeting from './components/meeting/enterMeeting';
import VideoConfig from './components/config';
import LineList from './components/config/lineList';
import CreditorsMeeting from './components/meeting/creditorsMeeting';
import AdminMeeting from './components/meeting/adminMeeting';
import { mapState } from 'vuex';
import { getMeetingCount, getMeetingList } from '@/serve/meeting';
import { getUserList, getUserListNum } from '@/serve/user';
import { getLiveConfig, getDomainList, appointLine } from '@/serve/live';
import { thistle } from 'color-name';
export default {
    components: {
        AddMeeting,
        EnterMeeting,
        VideoConfig,
        CreditorsMeeting,
        AdminMeeting,
        LineList
    },
    created() {
        if (this.userInfo.type !== 'ADMIN') {
            this.meetingForm.began = null;
            this.meetingForm.ended = null;
            this.meetingForm.test = null;
        }
        this.getMeetingList();
        this.getUserList();
        this.getDomainList();
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.userInfo
        })
    },
    methods: {
        toggleMeeting(attr) {
            this.tableData = [];
            this.loading = true;
            this.meetingForm = {
                began: false,
                ended: false,
                test: false,
                subject: '',
                page: 0,
                rows: 20,
                sort: ''
            };
            if (attr == 'began') {
                this.meetingForm.began = true;
            } else if (attr == 'test') {
                this.meetingForm.test = true;
            } else if (attr == 'ended') {
                this.meetingForm.began = true;
                this.meetingForm.ended = true;
                this.meetingForm.sort = 'endTime desc'
            }
            this.getMeetingList();
        },
        // 获取用户列表
        getUserList() {
            let param = { type: 'MANAGER' }
            getUserListNum(param).then(viod => {
                this.managerForm.rows = viod
                getUserList(this.managerForm)
                    .then(res => {
                        // console.log(res)
                        this.managerList = res;
                    })
                    .catch(err => {
                        this.$message.error('获取用户失败');
                    });
            }).catch(err => {
                this.$message.error('获取用户失败');
            });

        },
        // 搜索会议列表
        searchMeeting(form) {
            this.meetingForm = form;
            // this.meetingForm.page = 0;
            // this.meetingForm.rows = 20;
            this.getMeetingList();
        },
        // 获取会议列表
        async getMeetingList() {
            this.loading = true;
            this.meetingForm.field = "personNum";
            this.total = await getMeetingCount(this.meetingForm);
			if(this.total>0){
				this.tableData = await getMeetingList(this.meetingForm);
				for (let i in this.tableData) {
					this.tableData[i].visibleChange = false;
					this.tableData[i].index = i;
				}
			}else{
				this.tableData = []
			}
            // this.total > 0 ? (this.tableData = await getMeetingList(this.meetingForm)) : (this.tableData = []);
            this.loading = false;
			console.log("tableData",this.tableData)
        },
        // 获取域名列表
        getDomainList() {
            getDomainList()
                .then(res => {
                    this.domainList = res;
                })
                .catch(err => {
                    this.$message.error('域名列表获取失败');
                });
        },
        // 默认设置
        defaultSet() {
            getLiveConfig(this.meetingId)
                .then(res => {
                    appointLine(res[0].meetingId, res[0].id).then(() => {
                        this.getMeetingConfig(this.meetingId);
                    });
                })
                .catch(err => {
                    this.$message.error(err.data.message);
                });
        },
        // 获取直播配置
        getMeetingConfig(row) {
            if (typeof row === 'object') {
                this.meetingInfo = JSON.parse(JSON.stringify(row));
                this.meetingId = row.id;
            } else {
                this.meetingId = row;
            }
			console.log("meetingInfo:",this.meetingInfo)
            getLiveConfig(this.meetingId)
                .then(res => {
                    this.config = res;
                })
                .catch(err => {
                    this.$message.error(err.data.message);
                });
        },
        // 进入会议
        enterMeeting(row, isShow) {
			console.log("meetingData:",this.meetingData);
            this.meetingData.push(row);
			console.log("row:",row);
            this.isBtnShow = isShow;
        },
        editMeeting(row) {
            this.ruleForm = { ...row };
        },
        // 编辑线路
        editLine(row) {
            this.configForm = { ...row };
            this.isConfigEdit = true;
        },
        addMeeting() {
            this.ruleForm = {
                subject: '',
                name: '',
                startTime: '',
                sponsor: '',
                managerUserId: '',
            };
        },
        resetForm() {
            this.isConfigEdit = false;
            this.configForm = {
                name: '',
                pushDomainName: '',
                appName: '',
                streamName: '',
                liveName: '',
                livePushUrl: ''
            };
        },
        toggleVisible(visible, flag, row) {
            this[visible] = !this[visible];
            // this.meetingInfo = {};
            if (visible == 'goIntoDialogVisible') {
                // console.log('row', row)
                this.meetingInfo = row
                this.meetingData = [];
            }
            if (flag) {
                this.isEdit = flag;
            } else {
                this.isEdit = false;
            }
        },

    },
    data() {
        return {
            meetingInfo: {},
            meetingId: '',
            loading: false,
            total: 0,
            isBtnShow: false,
            isEdit: false,
            isConfigEdit: false,
            newDialogVisible: false,
            lineDialogVisible: false,
            centerDialogVisible: false,
            goIntoDialogVisible: false,
            seeDialogVisible: false,
            detailDialogVisible: false,
            innerVisible: false,
            aboutVoteVisible: false,
            managerList: [],
            domainList: [],
            config: [],
            configForm: {
                name: '',
                pushDomainName: '',
                appName: '',
                streamName: '',
                liveName: '',
                livePushUrl: ''
            },
            meetingForm: {
                began: false,
                ended: false,
                test: false,
                subject: '',
                name: '',
                page: 0,
                rows: 20
            },
            // 新建/编辑会议表单
            ruleForm: {
				startTime:'',
			},
            managerForm: {
                name: '',
                page: 0,
                rows: 20,
                ban: false,
                type: 'MANAGER',
                username: ''
            },
            meetingData: [],
            tableData: [],
            meetingDocumentData: [],
            meetingVoteData: [],
            formInline: {
                subject: '',
                name: '',
                page: 0,
                rows: 20
            },
            options: [],
            value: ''
        };
    }
};
</script>
<style scoped lang="scss">

</style>
